<div class="tile">
  <h5 class="mb-4 font-medium">
    {{ 'instrument-detail.instrument-related-links.headline' | transloco }}
  </h5>
  <div class="row">
    <ng-container *ngTemplateOutlet="link; context: { key: 'balance-sheet' }" />
    <ng-container *ngTemplateOutlet="link; context: { key: 'goals' }" />
  </div>
  <hr class="less-margin" />
  <div class="row">
    <ng-container *ngTemplateOutlet="link; context: { key: 'estimation' }" />
    <ng-container *ngTemplateOutlet="link; context: { key: 'dates' }" />
  </div>
  <hr class="less-margin" />
  <div class="row">
    <ng-container *ngTemplateOutlet="link; context: { key: 'dividend' }" />
    <ng-container *ngTemplateOutlet="link; context: { key: 'insider-trades' }" />
  </div>
</div>

<ng-template #link let-key="key">
  <div class="col-6">
    <a
      [href]="('instrument-detail.instrument-related-links.' + key + '.link' | transloco) + '?isin=' + isin"
      target="_blank"
      rel="noopener noreferrer"
      class="link-secondary text-default"
    >
      {{ 'instrument-detail.instrument-related-links.' + key + '.label' | transloco }}
    </a>
  </div>
</ng-template>
